import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  root: {
    width: '100%',
    paddingLeft: '30px'
  },
  title: {
    fontWeight: '500',
    color: '#248'
  }
});
